import { render, staticRenderFns } from "./Planejamento.vue?vue&type=template&id=478259e6&scoped=true"
import script from "./Planejamento.vue?vue&type=script&lang=js"
export * from "./Planejamento.vue?vue&type=script&lang=js"
import style0 from "./Planejamento.vue?vue&type=style&index=0&id=478259e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478259e6",
  null
  
)

export default component.exports